import { useLayoutEffect, useRef } from "react";
import { EditableRegion } from "../core/form/EditableRegion";
import { HeadingElement, StructureHeading, usePresenter } from "./types"

export function Heading(props: {
	def: HeadingElement,
}) {
	const presenter = usePresenter();

	const ref = useRef<any>();

	const structureHeading = useRef<StructureHeading>();

	// need to set up the structure heading immediately so its available for container processing logic
	if (props.def.outline) {
		structureHeading.current = {
			title: props.def.title!,
		};
		presenter.structureHeadings.push(structureHeading.current);	
	}	

	// but once we have an element we need to assign that back as well
	useLayoutEffect(() => {
		if (props.def.outline) {
			structureHeading.current!.element = ref.current;
		}	
	}, [props.def]);

	let title;
	if (presenter.designMode) {
		title = 
			<EditableRegion
				intialHtml={props.def.title}
				onChange={(e) => {
					props.def.title = e.target.value;
				}}
			/>
	} else {
		title = props.def.title;
	}

	return (
		<h2 ref={ref} className="heading font-med margin-0 flex horiz align-center">{title}</h2>
	)
}